/** Dashboard grouping IDs are not persisted folder authorization targets. */
export function isVirtualFolderId(id: string): boolean {
  return id.startsWith('home-') || id.startsWith('shared-');
}
